import React, {forwardRef} from 'react'
import {Lang} from 'yougile-lang'
import {Time} from 'yougile-util'
import {TwAdditionalInfo, TwDateTime, TwEditedAt} from './containers'
import {SeenBy} from './seen-by'
import {SeenBy as SeenByWhom} from './types'

interface AdditionalInfoBaseProps {
  seenBy?: SeenByWhom
  seenByTitle?: string
  timestamp: number
  editedTimestamp?: number
  className?: string
}

export const AdditionalInfoBase = forwardRef(
  (
    {
      timestamp,
      editedTimestamp,
      seenBy,
      seenByTitle,
      className
    }: AdditionalInfoBaseProps,
    ref: React.Ref<typeof TwAdditionalInfo>
  ) => (
    <TwAdditionalInfo className={className} ref={ref}>
      {editedTimestamp && (
        <TwEditedAt
          componentTag="span"
          content={Lang.msg.messageEditedHint(
            Time.formatDateTime(editedTimestamp)
          )}
        >
          {Lang.msg.messageEdited}
        </TwEditedAt>
      )}
      <TwDateTime componentTag="span" timestamp={timestamp} />
      {seenBy && <SeenBy seenBy={seenBy} title={seenByTitle} />}
    </TwAdditionalInfo>
  )
)

export const AdditionalInfo = (props: AdditionalInfoBaseProps) => {
  const {timestamp, editedTimestamp, seenBy, seenByTitle} = props

  return (
    <AdditionalInfoBase
      timestamp={timestamp}
      editedTimestamp={editedTimestamp}
      seenBy={seenBy}
      seenByTitle={seenByTitle}
    />
  )
}
